import get from 'lodash/get';
import snakeCase from 'lodash/snakeCase';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { UiContextService } from '../services/ui-context.service';

@Pipe({
  standalone: false,
  name: 'multiImage'
})
export class MultiImagePipe implements PipeTransform {
  constructor(
    private _uiContextService: UiContextService,
    @Inject('AppConfig') private _appConfig: any) {
  }

  transform(pictureId: number, size: string, compressed = true, fallbackUrl: string): string {
    if (pictureId && this._appConfig && get(this._appConfig, 'api.extra')) {
      let { host, images } = this._appConfig.api.extra;

      let url = `${host}${images}${pictureId}/?size=${snakeCase(size || 'originalUrl')}`;
      let compressionType = null;
      if (compressed) {
        compressionType = this._uiContextService.isWebpSupported ? 'webp' : 'original';
        url += `&compress_type=${compressionType}`;
      }

      return url;
    }

    console.warn(
      `Not possible to get proper url for image,
      please check if configuration has "api.extra" configured,
      using fallbackUrl: ${fallbackUrl}
      pictureId: ${pictureId},
      size: ${size}
      compressed: ${compressed}`
    );

    return fallbackUrl || '';
  }
}
